import { render, staticRenderFns } from "./TradeHeadOrder.vue?vue&type=template&id=117d727a"
import script from "./TradeHeadOrder.vue?vue&type=script&lang=js"
export * from "./TradeHeadOrder.vue?vue&type=script&lang=js"
import style0 from "./TradeHeadOrder.vue?vue&type=style&index=0&id=117d727a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports